import { getCardsLk } from '../api/bitrix/cards-lk/cardsLkApi'
import { cardsLkAdapter } from '../api/bitrix/cards-lk/cardsLkAdapter'
import { CardsLkAdapted, CardsLkItem } from '../contracts/CardsLk'

type CardsLkState = {
  data: CardsLkAdapted | null
  loading: boolean
}

export const state = (): CardsLkState => ({
  data: null,
  loading: false,
})

export const getters = {
  businessItems: (state: CardsLkState): CardsLkItem[] =>
    state.data?.sections.find((section) => section.code === 'business')
      ?.items || [],
  isLoading: (state: CardsLkState) => state.loading,
  isLoaded: (state: CardsLkState) => state.data !== null,
}

export const mutations = {
  SET_DATA(state: CardsLkState, value: CardsLkAdapted | null) {
    state.data = value
  },
  SET_LOADING(state: CardsLkState, value: boolean) {
    state.loading = value
  },
}

export const actions = {
  async fetch({ commit, state }, ctx) {
    if (state.data || state.loading) {
      return
    }
    commit('SET_LOADING', true)
    try {
      const response = await getCardsLk(ctx)
      if (response.data?.status !== 'success') {
        throw new Error('cardsLk: unexpected response status')
      }
      commit(
        'SET_DATA',
        cardsLkAdapter(response.data, ctx?.$config?.URL_MEDIA_REWRITE || '')
      )
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error('Unable to load cardsLk', e)
    } finally {
      commit('SET_LOADING', false)
    }
  },
}
